import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import MbCheckList from 'components/molecules/MbCheckList';
import NewButton from 'components/molecules/NewButton';

let initialRender = true;

const useStyles = makeStyles((theme) => ({
  checkBoxWrap: {
    '& > div': {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: 10,
      '&:first-child': { width: 140, justifyContent: 'space-between' },
    },
  },
}));

/**
 * 체크박스 반복문으로 들어오는 리스트 체크박스로 만들어주는 컴포넌트
 * @param props
 * @returns {*}
 * @constructor
 */
const CheckboxGroup = (props) => {
  const {
    name,
    labelKey,
    valueKey,
    optionList = [],
    params,
    handleGetValue = (f, name) => f,
    getSelectValue = (f) => f,
    handleAllCheck = (f) => f,
    controllOption = {},
    selectedOption,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [checkArray, setCheckArray] = useState(selectedOption);

  useEffect(() => {
    initialRender = false;
  }, []);

  useEffect(() => {
    setCheckArray(selectedOption);
    // eslint-disable-next-line
  }, [selectedOption]);

  /**
   * @param value
   * 체크박스를 클릭했을때 실행되는 함수
   * checkArray에 담아뒀다가 params값이랑 같이 부모 컴포넌트에 전달
   */
  const handleOnClick = (value) => {
    let newArray = [...checkArray];
    if (newArray.includes(value)) {
      newArray.splice(newArray.indexOf(value), 1);
    } else {
      newArray.push(value);
    }
    setCheckArray(newArray);
    let newParams = { ...params };
    if (newArray.length !== 0) {
      newParams = { ...newParams, [name]: newArray.toString() };
    } else {
      delete newParams[name];
    }
    if (!initialRender) {
      handleGetValue(newParams, name);
      getSelectValue(newArray);
    }
  };

  const handleCheck = (value) => {
    let tmpArray = [];

    if (value === true) {
      for (let i = 0; i < optionList.length; i++) {
        tmpArray.push(String(optionList[i][valueKey]));
      }
      setCheckArray(tmpArray);
      const newParams = { ...params, [name]: tmpArray.toString() };
      handleGetValue(newParams, name);
    } else {
      let newParams = { ...params };
      delete newParams[name];

      setCheckArray([]);
      handleGetValue(newParams, name);
    }
    handleAllCheck(tmpArray);
  };

  const makeCheckbox = () => {
    let checkList = [];
    for (let i = 0; i < optionList.length; i++) {
      let newValue = String(optionList[i][valueKey]);
      let checked = false;
      if (checkArray !== undefined) {
        if (checkArray.includes(newValue)) {
          checked = true;
        }
      }
      checkList.push(
        <MbCheckList
          key={optionList[i][labelKey]}
          label={optionList[i][labelKey]}
          value={optionList[i][valueKey]}
          onClick={() => handleOnClick(newValue)}
          checked={checked}
        />
      );
    }
    return checkList;
  };

  return (
    <div className={classes.checkBoxWrap}>
      {typeof controllOption.type !== 'undefined' &&
        controllOption.type === 'all' && (
          <div>
            <NewButton type={'filterButton'} onClick={() => handleCheck(true)}>
              {t('전체선택')}
            </NewButton>
            <NewButton type={'filterButton'} onClick={() => handleCheck(false)}>
              {t('전체해제')}
            </NewButton>
          </div>
        )}
      {optionList.length > 0 && <div>{makeCheckbox(props)}</div>}
    </div>
  );
};

export default CheckboxGroup;
